"use client"

import { ChartNoAxesColumnIncreasing } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChartNoAxesColumnIncreasingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChartNoAxesColumnIncreasingIcon = component(Icon)({
  as: ChartNoAxesColumnIncreasing,
})
